import { Component, OnInit } from '@angular/core'
import { ActivatedRoute } from '@angular/router'
import { ResourceSlug } from '../../../../shared/enums/wordpress/wp-resource-slug.enum'
import { BreadcrumbLink } from '../../../../shared/interfaces/breadcrumb-link.interface'
import { BreadcrumbService } from '../../../../shared/services/breadcrumb.service'

@Component({
  selector: 'app-thank-you',
  templateUrl: './thank-you.component.html',
  styleUrls: ['./thank-you.component.scss']
})
export class ThankYouComponent implements OnInit {
  breadcrumbLinks: BreadcrumbLink[]

  resource: ResourceSlug
  ResourceSlug = ResourceSlug

  constructor(
    private activatedRoute: ActivatedRoute,
    breadcrumbService: BreadcrumbService
  ) {
    this.breadcrumbLinks = breadcrumbService.getBreadCrumbLinks('toolCatalog', [
      {
        label: 'Thank you'
      }
    ])
  }

  ngOnInit(): void {
    this.resource = this.activatedRoute.snapshot.data.resource
  }
}
